// De onde veio o cliente: UTM e ids de clique (Google e Meta) da URL de
// entrada. Vai junto com o pedido (checkoutSlice.submitCheckout), para o
// backend enviar a Conversions API e para a loja ver venda por campanha
// mesmo quando o pedido fecha no WhatsApp ou o navegador bloqueia o pixel.
//
// Precisa ser lido no boot: o useGoTo navega com history.replace e a query
// string some na primeira navegação.
//
// Regra "último clique não direto": só uma visita que traz algum desses
// parâmetros sobrescreve a anterior; visita direta mantém a campanha até ela
// expirar. Fica no localStorage, fora do redux-persist, para não mexer no
// shape de slice persistido.

const PARAMS = [
  ["utm_source", "utmSource"],
  ["utm_medium", "utmMedium"],
  ["utm_campaign", "utmCampaign"],
  ["utm_term", "utmTerm"],
  ["utm_content", "utmContent"],
  ["gclid", "gclid"],
  ["gbraid", "gbraid"],
  ["wbraid", "wbraid"],
  ["fbclid", "fbclid"],
];

// janela de clique padrão do Meta
export const ATTRIBUTION_TTL_MS = 7 * 24 * 60 * 60 * 1000;

const storageKey = (namespace) => `pallas:attribution:${namespace || ""}`;

export function parseAttribution(search) {
  const query = new URLSearchParams(search || "");
  return PARAMS.reduce((acc, [param, key]) => {
    const value = query.get(param);
    if (value) acc[key] = value.slice(0, 500);
    return acc;
  }, {});
}

export function captureAttribution(
  namespace,
  { search, href, referrer, now = Date.now() } = {},
) {
  const found = parseAttribution(search);
  if (Object.keys(found).length === 0) return;

  const attribution = {
    ...found,
    landingUrl: href || null,
    referrer: referrer || null,
    capturedAt: now,
  };
  try {
    window.localStorage.setItem(
      storageKey(namespace),
      JSON.stringify(attribution),
    );
  } catch {
    // sem localStorage (aba anônima, bloqueado): fica sem atribuição
  }
}

export function readAttribution(namespace, now = Date.now()) {
  try {
    const raw = window.localStorage.getItem(storageKey(namespace));
    if (!raw) return null;
    const attribution = JSON.parse(raw);
    if (!attribution || now - attribution.capturedAt > ATTRIBUTION_TTL_MS) {
      window.localStorage.removeItem(storageKey(namespace));
      return null;
    }
    return attribution;
  } catch {
    return null;
  }
}

function readCookie(name) {
  try {
    const match = document.cookie.match(
      new RegExp("(?:^|;\\s*)" + name + "=([^;]*)"),
    );
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

/**
 * Tudo o que o backend precisa para a Conversions API e para gravar a origem
 * do pedido. `fbp` e `fbc` vão crus (a Meta rejeita hash neles). Sem o cookie
 * `_fbc` (pixel bloqueado ou carregado depois), monta-se o valor a partir do
 * `fbclid` guardado, no formato que a Meta documenta.
 */
export function getMarketingContext(namespace, now = Date.now()) {
  const attribution = readAttribution(namespace, now) || {};
  const fbc =
    readCookie("_fbc") ||
    (attribution.fbclid
      ? `fb.1.${attribution.capturedAt}.${attribution.fbclid}`
      : null);

  return {
    utmSource: null,
    utmMedium: null,
    utmCampaign: null,
    utmTerm: null,
    utmContent: null,
    gclid: null,
    gbraid: null,
    wbraid: null,
    fbclid: null,
    landingUrl: null,
    referrer: null,
    capturedAt: null,
    ...attribution,
    fbp: readCookie("_fbp"),
    fbc,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
    eventSourceUrl: window.location.href,
  };
}
